import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/pages/articles/privacy-policy.tsx");
